/**
 * Feedback haptique léger pour confirmer une action gestuelle.
 *
 * iOS Safari : `navigator.vibrate` est défini mais ne fait rien (Apple
 * n'expose pas le Taptic Engine au web). On garde l'appel quand même —
 * sur Android Chrome PWA et autres, ça vibre. Best-effort, no-op safe.
 *
 * Mappings rough (en ms) — calés sur les patterns iOS-like :
 *  - light   : tick discret (swipe completion, snap)
 *  - medium  : action engagée (toggle, confirm)
 *  - heavy   : warning / undo / destructive
 */

import { settingsState } from "../settings.svelte";

type HapticStrength = "light" | "medium" | "heavy";

const VIBE_MS: Record<HapticStrength, number> = {
  light: 5,
  medium: 12,
  heavy: 25,
};

export function haptic(strength: HapticStrength = "light"): void {
  if (typeof navigator === "undefined") return;
  // Réglable : certains n'en veulent pas, et sur Android la vibration se
  // sent vraiment.
  if (!settingsState.haptic) return;
  const v = (navigator as Navigator & { vibrate?: (p: number) => boolean })
    .vibrate;
  if (typeof v !== "function") return;
  try {
    v.call(navigator, VIBE_MS[strength]);
  } catch {
    // ignore
  }
}
